import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Organisation } from "../types/Organisation";
import { client } from "src/utils/axios-client";
import { PagedList } from 'src/types/common';
import ApplicationStore from "../stores/ApplicationStore";

export const ServerStateKey = ['customer-list'];
export const apiUri = '/api/organizations';

export const useGetItems = (pageNumber: number, pageSize: number, searchTerm: string) => useQuery<PagedList<Organisation>>({
    queryKey: ServerStateKey,
    queryFn: () => client.get(apiUri, { params: { pageSize, pageNumber, searchTerm } }).then((res) => res.data)
});

export const useUpdateItem = () => {
    const cache = useQueryClient();

    return useMutation(
        (updatedItem: Organisation) => client.put(apiUri, updatedItem).then((res) => res.data),
        {
            onSuccess: () => {
                cache.invalidateQueries(ServerStateKey);

                ApplicationStore.update(s => {
                    s.snackbarMessage = "Organisation saved successfully";
                    s.snackbarOpen = true;
                });
            }
        })
}